import 'core-js/stable';
import 'regenerator-runtime/runtime';
import cssVars from 'css-vars-ponyfill';
import LazyLoad from 'vanilla-lazyload';

// cssVars options
cssVars({});

const themePrefix = 'vd';
window.themePrefix = 'vd';

import './helper/focus';

//import './image/lazyLoading';

// components
import './components/filter';
import './components/navigation';
import './components/navigation__mobile';
import './components/hero';
import './components/accordion';
import './components/carousel';
import './components/datepicker';
import './components/lightbox';
//import './components/sharing';
import './components/tooltip';
import './components/table';
import './components/form';
import './components/toggle-bar';
import './components/multipleSelect';

import './components/resultList/item';
import './components/resultList/scrollIntoView';

//import 'SocialMedia/ContentElements/_social_wall';

// modules
import 'NEWS/Modules/Actions/filterListAction';
import './Controller/MedicalJournal/filterAction';
//import 'Search/Modules/Search/_solr';

import './print';

const domReady = (cb) => {
  document.readyState === 'interactive' || document.readyState === 'complete'
    ? cb()
    : document.addEventListener('DOMContentLoaded', cb);
};

domReady(() => {
  // Display body when DOM is loaded
  document.body.style.visibility = 'visible';
  require('./image/lazyLoading');
});
